import {useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { useAuthContext } from '../hooks/useAuthContext'
import Loader from './Loader'

const Landing = () => {
    const {user} = useAuthContext()
    const navigate = useNavigate()

    function StartButton() {
        return (
            <button className="landing-signup-btn" onClick={() => navigate('/signup')}>Get Started</button>
        )
    }

    useEffect(() => {  //code that runs after render //useEffects are side effects that happens when something renders/something changes
        if (user) {
            navigate('/dashboard')
            return
        }
    }, [user, navigate])  //with an empty array it only fires once when the component renders, things like [count] re-runs each time count state changes

    if (user) {
        return <Loader />
    }

    return (
        <div className="landing">
            <div className="landing-top-paragraph">
                <h3>Easily plan your next trip with <span className="logo-clr">Ezy Tripz</span></h3>
                <p>A simple site to manage your travel itinerary, flights, accomodation and more!</p>
                <StartButton />
            </div>
            <div className="explanation-container">
                <div className="itinerary-img">
                    <img src="/images/itinerary-details.jpg" alt="itinerary-image" />
                </div>
                <div>
                    <h1>Itinerary Activity Planning</h1>
                    <p>Plan every adventure! Add, edit, or remove activities so your trip is exactly how you want it!</p>
                </div>
            </div>
            <div className="explanation-container">
                <div className="accomodation-img">
                    <img src="/images/accomodation-details.jpg" alt="accomodation-image" />
                </div>
                <div>
                    <h1>Accomodation Planning</h1>
                    <p>Stay smart! Save, update, or delete your hotels and rentals all in one place!</p>
                </div>
            </div>
            <div className="explanation-container">
                <div className="flight-img">
                    <img src="/images/flight-details.jpg" alt="flight-image" />
                </div>
                <div>
                    <h1>Flight Planning</h1>
                    <p>Travel with ease! Keep track of all your flights and make changes on the go!</p>
                </div>
            </div>
            <div className="explanation-container">
                <div className="all-trips-img">
                    <img src="/images/all-trips.jpg" alt="all-trips-image" />
                </div>
                <div>
                    <h1>Manage Trips</h1>
                    <p>Your trips at a glance! Add new trips, remove old ones, and see all your upcoming adventures neatly on one dashboard!</p>
                </div>
            </div>
        </div>
    )
}

export default Landing